import React, { Fragment } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CardContainer from '../CardContainer';
import { formatDate } from '../../utils';
import useStyles from './CardPrayerOther.styles';

interface Props {
  date: string
  prayerType: string
}

const OtherPrayerCard: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { date, prayerType } = props;
  return (
    <Fragment>
      <CardContainer>
        <Typography className={classes.title} variant="body2">
          {formatDate(date)}
        </Typography>
        <Box marginTop={1}>
          <Typography className={classes.value} variant="body2">
            {prayerType}
          </Typography>
        </Box>
      </CardContainer>
    </Fragment>
  );
};

export default OtherPrayerCard;
